import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charge_channels',
  component: Management,
  redirect: '/charge_channels/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charge_channels/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listChargeChannels
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/charge_channels/ListTable'),
          meta: {
            auth: Auth.listChargeChannels,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/charge_channels/New'),
      meta: {
        auth: Auth.createChargeChannel
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/charge_channels/Edit'),
      meta: {
        auth: Auth.updateChargeChannel
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/charge_channels/DetailLayout'),
      meta: {
        auth: Auth.showChargeChannel
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charge_channels/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeChannel
          }
        }
      ]
    }
  ]
}
